// extracted by mini-css-extract-plugin
export var cardContainer = "_pf-0";
export var cardHeader = "_pf-2";
export var collapsedState = "_pf-3";
export var dragHandle = "_pf-5";
export var dragHandleIcon = "_pf-6";
export var dragging = "_pf-1";
export var titleArea = "_pf-4";